import {ChangeDetectionStrategy, Component, inject, input, output} from '@angular/core';
import {BaseDesignBlockFile} from "../../types/design-block-files.types";
import {DeleteFileParams} from "../../../../../types/product-card-files.types";
import {DbFilesStateService} from "../../services/db-files-state.service";
import {DbFilePathStateService} from "../../services/db-file-path-state.service";
import {DesignBlockFilesService} from "../../services/design-block-files.service";
import {defaultBaseDesignBlockFile} from "../../configs/default-base-design-block-file";
import {EntityFileType} from "../../../../../../../../core/types/file.types";
import {RecordUpdateRequestParams} from "../../../../../../../../core/types/records-table.types";
import {MatFormField, MatInput, MatLabel} from "@angular/material/input";
import {FormsModule} from "@angular/forms";
import {FileCardComponent} from "../../../../../../../../shared/components/ui/file-card/file-card.component";

@Component({
  selector: 'div[app-db-file-card]',
  standalone: true,
  imports: [
    MatFormField,
    MatLabel,
    MatInput,
    FormsModule,
    FileCardComponent
  ],
  templateUrl: './db-file-card.component.html',
  styleUrl: './db-file-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DbFileCardComponent {
  file = input<BaseDesignBlockFile>(defaultBaseDesignBlockFile);
  designBlockEntityFileType = input<EntityFileType>('LISTING');
  isEditModeActive = input<boolean>(false);
  updateField = output<BaseDesignBlockFile>();

  public dbFilesStateService: DbFilesStateService = inject(DbFilesStateService);
  private dbFilePathStateService: DbFilePathStateService = inject(DbFilePathStateService);
  private designBlockFilesService: DesignBlockFilesService = inject(DesignBlockFilesService);

  public async handleUpdateField(key: string): Promise<void> {
    const params: RecordUpdateRequestParams = {
      path: this.dbFilePathStateService.pathFileState(),
      recordId: this.file().id,
      fieldName: key,
      value: this.file()[key]
    };

    const updateData = await this.designBlockFilesService.updatedRecordField<BaseDesignBlockFile>(params).catch(() => this.file());
    this.updateField.emit(updateData);
  }

  public handleDelete(isImage: boolean, file: BaseDesignBlockFile): void {
    const params: DeleteFileParams = {
      path: this.dbFilePathStateService.pathFileState(),
      id: file.id
    };

    this.designBlockFilesService.deleteFile(params)
      .then(() => this.dbFilesStateService.deleteFileById(file.id));
  }
}
